import * as React from 'react';

import {NumberedBreadcrumbs} from 'shells/numbered-breadcrumbs/numbered-breadcrumbs';
import type {Breadcrumb} from 'shells/numbered-breadcrumbs/numbered-breadcrumbs';

import {VIEWS} from './consts';
import type {ChatOnboardingView} from './consts';

type Props = {
    currentView: ChatOnboardingView;
    setCurrentView: (view: ChatOnboardingView) => void;
    domain: string;
    isCrawling: boolean;
};

export function ChatOnboardingBreadcrumbs(props: Props) {
    const breadcrumbs: Breadcrumb[] = [
        {
            id: VIEWS.YOUR_WEBSITE_VIEW,
            title: 'Your website',
            subtitle: props.domain,
            selectable: true,
        },
        {
            id: VIEWS.INTERACTIVE_PREVIEW_VIEW,
            title: 'Preview engagement bar',
            selectable: props.currentView === VIEWS.EMBED_CHATBOT_VIEW,
        },
        {
            id: VIEWS.EMBED_CHATBOT_VIEW,
            title: 'Embed it',
            selectable: props.currentView === VIEWS.INTERACTIVE_PREVIEW_VIEW && !props.isCrawling,
        },
    ];

    return (
        <NumberedBreadcrumbs
            breadcrumbs={breadcrumbs}
            selectedValue={props.currentView}
            // @ts-expect-error
            onSelectValue={(view: ChatOnboardingView) => props.setCurrentView(view)}
            onlyDisplaySubtitleWhenCompleted={true}
            subtitleSize='mini'
            subtitleColor='light'
        />
    );
}
